import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_search",
  "use": "icon-icon_search-usage",
  "viewBox": "0 0 16.12 16.125",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.12 16.125\" id=\"icon-icon_search\">\n  <defs>\n  </defs>\n  <path id=\"icon-icon_search_形状_1\" data-name=\"形状 1\" class=\"cls-1\" d=\"M1534.66,56.733l-2.78-2.789a7.246,7.246,0,1,0-.93.927l2.79,2.789a0.632,0.632,0,0,0,.46.193,0.649,0.649,0,0,0,.46-0.193,0.659,0.659,0,0,0,0-.926h0Zm-8.31-1.5a5.887,5.887,0,1,1,5.88-5.887,5.893,5.893,0,0,1-5.88,5.887h0Zm0,0\" transform=\"translate(-1518.94 -41.938)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol